// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"


document.addEventListener("turbo:load", () => {
  // Only scroll if there is no turbo-frame targeted
  if (!document.querySelector("turbo-frame")) {
    window.scrollTo(0, 0)
  }
})

